import { Box, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import React from 'react';

import { ExpertRegistrationView } from '../expertRegistrationView';

export const ExpertRegistrationTab = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Helmet title={t(`mainScreen.tab.ekspertregistrering`)} />
      <Typography variant="h2" mb={3}>
        {t('mainScreen.tab.ekspertregistrering')}
      </Typography>
      <ExpertRegistrationView />
    </Box>
  );
};
